import axios, { AxiosResponse } from "axios";
import { message } from "antd";
import { isEnv } from "../utils";
import router from "../router";


let _baseURl: string

export function getBaseUrl(): string {
  if (!_baseURl) {
    _baseURl = "//www.myjuhe.com"
    if (isEnv("test")) {
      _baseURl = "//test.myjuhe.com"
      if (window.location.hostname === "localhost") {
        _baseURl = "https://test.myjuhe.com"
      }
    }
  }
  return _baseURl;
}

const request = axios.create({
  baseURL: getBaseUrl(),
  validateStatus: (status: number) => {
    if (status >= 200 && status < 300) {
      return true;
    }
    if (status >= 400 && status < 500) {
      return true;
    }
    return false;
  },
});

request.interceptors.response.use(
  (response) => {
    if (response && response.data && response.data.code === 1401) {
      // token失效
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      router.navigate("/login");
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export interface IResponse<T extends any> {
  code: number;
  data: T;
  message: string;
}

// export interface AxiosResponse<T extends any> {
//   headers: AxiosHeaders;
//   request: XMLHttpRequest;
//   status: number;
//   statusText: string;
//   data: IResponse<T>;
// }

export const handleResponse = (res: AxiosResponse<any>) => {
  if (res && res.data) {
    return res.data;
  }
  throw new Error(res.status + "(" + res.statusText + ")");
};

export const handleThenable = <T extends any>(res: IResponse<T>) => {
  if (res && res.code === 0) {
    return res.data;
  }
  throw res;
};

export const headers: Record<string, string> = {};

try {
  let token = null;
  const tokenStr = localStorage.getItem("token");
  if (tokenStr) {
    token = JSON.parse(tokenStr);
    if (token && token.access_token) {
      headers.Authorization = "Bearer " + token.access_token;
      // 更新用户信息
      request
        .post("/api/user/info", null, {
          headers,
        })
        .then(handleResponse)
        .then(handleThenable)
        .then(userInfo => {
          if (userInfo) {
            localStorage.setItem("user", JSON.stringify(userInfo));
          }
        });
    }
  }
} catch (e) {}

const fixed_error: Record<number, string> = {
  1000: "参数错误，未传对应的参数",
  1002: "手机号验证码错误",
  1003: "手机号错误",
  1004: "用户不存在",
  1005: "密码错误",
  1006: "验证码无效",
  1401: "token失效",
  1404: "数据不存在",
  1500: "服务端内部错误，重试",
};

interface anyError extends Error {
  code?: number;
  data?: string;
}

export const handleError = (error: anyError) => {
  if (error) {
    if (error.data && typeof error.data === "string") {
      message.warning(error.data);
    } else if (error.code && fixed_error[error.code]) {
      message.error(fixed_error[error.code]);
    } else if (error.message) {
      message.warning(error.message);
    }
  }
  throw error;
};

export default request;
